module.exports = __webpack_public_path__ + "img/STORY_comic.62b210f0.png";